import { useDispatch } from 'react-redux';
import { WarningBanner } from 'ui/banner';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { BUTTON_SIZES, Button, BUTTON_VARIANTS } from 'ui/button';
import { StyledModalBody } from './RestoreAsDraftConfirmationModal.styles';
import { RESTORE_AS_DRAFT_CONFIRMATION_MODAL } from '../../../constants';
import { closeModal } from '../../../ducks';

type RestoreAsDraftConfirmationModalProps = {
  isOpen: boolean;
  restoreDraft: () => void;
  hasDraft: boolean;
  date: string;
};

export const RestoreAsDraftConfirmationModal = ({
  isOpen,
  restoreDraft,
  hasDraft,
  date,
}: RestoreAsDraftConfirmationModalProps) => {
  const dispatch = useDispatch();
  const handleCloseModal = () => dispatch(closeModal(RESTORE_AS_DRAFT_CONFIRMATION_MODAL));

  const handleRestoreAsDraft = () => {
    restoreDraft();
    handleCloseModal();
  };

  return (
    <Modal
      id={RESTORE_AS_DRAFT_CONFIRMATION_MODAL}
      isModalOpen={isOpen}
      onClose={handleCloseModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Restore this version?</ModalHeader>
      <StyledModalBody>
        <div data-test={'restore-as-draft-modal-text'}>
          This will {hasDraft ? <b>overwrite the current draft</b> : <b>create a new draft</b>} of
          your journey with the tiles from <b>{date}</b>.
        </div>
        <div>(Don&#39;t worry — you can review the draft before publishing your changes.)</div>
        <WarningBanner Icon={false} data-test={'revert-warning'}>
          The campaigns associated with this journey won&#39;t be reverted to earlier versions.
        </WarningBanner>
      </StyledModalBody>
      <ModalFooter>
        <Button
          data-test={'restore-as-draft'}
          autoFocus
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
          onClick={() => handleRestoreAsDraft()}
        >
          {hasDraft ? 'Update draft' : 'Restore as draft'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
